"use client";
import React from "react";
import {Img} from "@/components/common/ui/Img";
import reactHtmlParser from "react-html-parser";

function Intro({data}) {
    return (
        <>
            <div className="intro ">
                <div className="intro-left">
                    <h1 className={'split-up'}>{reactHtmlParser(data?.section_data?.title)}</h1>
                </div>
            </div>


            <div className="overview">
                <h6 className={'split-up'}>{reactHtmlParser(data?.section_data?.subtitle)}</h6>
                <p className={'split-up'}>{reactHtmlParser(data?.section_data?.short_desc)}</p>
<br/><br/>
                {
                    data?.section_data?.description &&
                    reactHtmlParser(data?.section_data?.description)
                }
            </div>

            <div className="banner">
                <div className="banner-wrapper">
                    <Img  alt={data?.section_data?.title} src={data?.images?.list?.[0]?.full_path    }/>
                </div>
            </div>

        </>
    );
}

export default React.memo(Intro)